/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DeleteFailureTrackingResponse } from '../model';
// @ts-ignore
import { GetExportFailureTrackingsResponse } from '../model';
// @ts-ignore
import { GetFailureTrackingResponse } from '../model';
// @ts-ignore
import { GetFailureTrackingsResponse } from '../model';
// @ts-ignore
import { PostFailureTrackingRequest } from '../model';
// @ts-ignore
import { PostFailureTrackingResponse } from '../model';
// @ts-ignore
import { PutFailureTrackingRequest } from '../model';
// @ts-ignore
import { PutFailureTrackingResponse } from '../model';
/**
 * FailureTrackingsApi - axios parameter creator
 * @export
 */
export const FailureTrackingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeFailureTracking: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('closeFailureTracking', 'id', id)
            const localVarPath = `/api/failure-trackings/close/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostFailureTrackingRequest} postFailureTrackingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFailureTracking: async (postFailureTrackingRequest: PostFailureTrackingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postFailureTrackingRequest' is not null or undefined
            assertParamExists('createFailureTracking', 'postFailureTrackingRequest', postFailureTrackingRequest)
            const localVarPath = `/api/failure-trackings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postFailureTrackingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFailureTracking: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteFailureTracking', 'id', id)
            const localVarPath = `/api/failure-trackings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {string} [status] 
         * @param {string} [openDate] 
         * @param {string} [closedDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportFailureTracking: async (keyword?: string, status?: string, openDate?: string, closedDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/failure-trackings/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (openDate !== undefined) {
                localVarQueryParameter['openDate'] = openDate;
            }

            if (closedDate !== undefined) {
                localVarQueryParameter['closedDate'] = closedDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailureTracking: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFailureTracking', 'id', id)
            const localVarPath = `/api/failure-trackings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [orderBy] 
         * @param {string} [orderDesc] 
         * @param {string} [status] 
         * @param {string} [openDate] 
         * @param {string} [closedDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailureTrackingsByKeyword: async (keyword?: string, limit?: number, page?: number, orderBy?: string, orderDesc?: string, status?: string, openDate?: string, closedDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/failure-trackings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDesc !== undefined) {
                localVarQueryParameter['orderDesc'] = orderDesc;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (openDate !== undefined) {
                localVarQueryParameter['openDate'] = openDate;
            }

            if (closedDate !== undefined) {
                localVarQueryParameter['closedDate'] = closedDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutFailureTrackingRequest} putFailureTrackingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFailureTracking: async (id: string, putFailureTrackingRequest: PutFailureTrackingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateFailureTracking', 'id', id)
            // verify required parameter 'putFailureTrackingRequest' is not null or undefined
            assertParamExists('updateFailureTracking', 'putFailureTrackingRequest', putFailureTrackingRequest)
            const localVarPath = `/api/failure-trackings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putFailureTrackingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FailureTrackingsApi - functional programming interface
 * @export
 */
export const FailureTrackingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FailureTrackingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeFailureTracking(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFailureTrackingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeFailureTracking(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostFailureTrackingRequest} postFailureTrackingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFailureTracking(postFailureTrackingRequest: PostFailureTrackingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostFailureTrackingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFailureTracking(postFailureTrackingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFailureTracking(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteFailureTrackingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFailureTracking(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {string} [status] 
         * @param {string} [openDate] 
         * @param {string} [closedDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportFailureTracking(keyword?: string, status?: string, openDate?: string, closedDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExportFailureTrackingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportFailureTracking(keyword, status, openDate, closedDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFailureTracking(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFailureTrackingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFailureTracking(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [orderBy] 
         * @param {string} [orderDesc] 
         * @param {string} [status] 
         * @param {string} [openDate] 
         * @param {string} [closedDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFailureTrackingsByKeyword(keyword?: string, limit?: number, page?: number, orderBy?: string, orderDesc?: string, status?: string, openDate?: string, closedDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFailureTrackingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFailureTrackingsByKeyword(keyword, limit, page, orderBy, orderDesc, status, openDate, closedDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutFailureTrackingRequest} putFailureTrackingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFailureTracking(id: string, putFailureTrackingRequest: PutFailureTrackingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutFailureTrackingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFailureTracking(id, putFailureTrackingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FailureTrackingsApi - factory interface
 * @export
 */
export const FailureTrackingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FailureTrackingsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeFailureTracking(id: string, options?: any): AxiosPromise<GetFailureTrackingResponse> {
            return localVarFp.closeFailureTracking(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostFailureTrackingRequest} postFailureTrackingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFailureTracking(postFailureTrackingRequest: PostFailureTrackingRequest, options?: any): AxiosPromise<PostFailureTrackingResponse> {
            return localVarFp.createFailureTracking(postFailureTrackingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFailureTracking(id: string, options?: any): AxiosPromise<DeleteFailureTrackingResponse> {
            return localVarFp.deleteFailureTracking(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {string} [status] 
         * @param {string} [openDate] 
         * @param {string} [closedDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportFailureTracking(keyword?: string, status?: string, openDate?: string, closedDate?: string, options?: any): AxiosPromise<GetExportFailureTrackingsResponse> {
            return localVarFp.exportFailureTracking(keyword, status, openDate, closedDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailureTracking(id: string, options?: any): AxiosPromise<GetFailureTrackingResponse> {
            return localVarFp.getFailureTracking(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [orderBy] 
         * @param {string} [orderDesc] 
         * @param {string} [status] 
         * @param {string} [openDate] 
         * @param {string} [closedDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailureTrackingsByKeyword(keyword?: string, limit?: number, page?: number, orderBy?: string, orderDesc?: string, status?: string, openDate?: string, closedDate?: string, options?: any): AxiosPromise<GetFailureTrackingsResponse> {
            return localVarFp.getFailureTrackingsByKeyword(keyword, limit, page, orderBy, orderDesc, status, openDate, closedDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutFailureTrackingRequest} putFailureTrackingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFailureTracking(id: string, putFailureTrackingRequest: PutFailureTrackingRequest, options?: any): AxiosPromise<PutFailureTrackingResponse> {
            return localVarFp.updateFailureTracking(id, putFailureTrackingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for closeFailureTracking operation in FailureTrackingsApi.
 * @export
 * @interface FailureTrackingsApiCloseFailureTrackingRequest
 */
export interface FailureTrackingsApiCloseFailureTrackingRequest {
    /**
     * 
     * @type {string}
     * @memberof FailureTrackingsApiCloseFailureTracking
     */
    readonly id: string
}

/**
 * Request parameters for createFailureTracking operation in FailureTrackingsApi.
 * @export
 * @interface FailureTrackingsApiCreateFailureTrackingRequest
 */
export interface FailureTrackingsApiCreateFailureTrackingRequest {
    /**
     * 
     * @type {PostFailureTrackingRequest}
     * @memberof FailureTrackingsApiCreateFailureTracking
     */
    readonly postFailureTrackingRequest: PostFailureTrackingRequest
}

/**
 * Request parameters for deleteFailureTracking operation in FailureTrackingsApi.
 * @export
 * @interface FailureTrackingsApiDeleteFailureTrackingRequest
 */
export interface FailureTrackingsApiDeleteFailureTrackingRequest {
    /**
     * 
     * @type {string}
     * @memberof FailureTrackingsApiDeleteFailureTracking
     */
    readonly id: string
}

/**
 * Request parameters for exportFailureTracking operation in FailureTrackingsApi.
 * @export
 * @interface FailureTrackingsApiExportFailureTrackingRequest
 */
export interface FailureTrackingsApiExportFailureTrackingRequest {
    /**
     * 
     * @type {string}
     * @memberof FailureTrackingsApiExportFailureTracking
     */
    readonly keyword?: string

    /**
     * 
     * @type {string}
     * @memberof FailureTrackingsApiExportFailureTracking
     */
    readonly status?: string

    /**
     * 
     * @type {string}
     * @memberof FailureTrackingsApiExportFailureTracking
     */
    readonly openDate?: string

    /**
     * 
     * @type {string}
     * @memberof FailureTrackingsApiExportFailureTracking
     */
    readonly closedDate?: string
}

/**
 * Request parameters for getFailureTracking operation in FailureTrackingsApi.
 * @export
 * @interface FailureTrackingsApiGetFailureTrackingRequest
 */
export interface FailureTrackingsApiGetFailureTrackingRequest {
    /**
     * 
     * @type {string}
     * @memberof FailureTrackingsApiGetFailureTracking
     */
    readonly id: string
}

/**
 * Request parameters for getFailureTrackingsByKeyword operation in FailureTrackingsApi.
 * @export
 * @interface FailureTrackingsApiGetFailureTrackingsByKeywordRequest
 */
export interface FailureTrackingsApiGetFailureTrackingsByKeywordRequest {
    /**
     * 
     * @type {string}
     * @memberof FailureTrackingsApiGetFailureTrackingsByKeyword
     */
    readonly keyword?: string

    /**
     * 
     * @type {number}
     * @memberof FailureTrackingsApiGetFailureTrackingsByKeyword
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof FailureTrackingsApiGetFailureTrackingsByKeyword
     */
    readonly page?: number

    /**
     * 
     * @type {string}
     * @memberof FailureTrackingsApiGetFailureTrackingsByKeyword
     */
    readonly orderBy?: string

    /**
     * 
     * @type {string}
     * @memberof FailureTrackingsApiGetFailureTrackingsByKeyword
     */
    readonly orderDesc?: string

    /**
     * 
     * @type {string}
     * @memberof FailureTrackingsApiGetFailureTrackingsByKeyword
     */
    readonly status?: string

    /**
     * 
     * @type {string}
     * @memberof FailureTrackingsApiGetFailureTrackingsByKeyword
     */
    readonly openDate?: string

    /**
     * 
     * @type {string}
     * @memberof FailureTrackingsApiGetFailureTrackingsByKeyword
     */
    readonly closedDate?: string
}

/**
 * Request parameters for updateFailureTracking operation in FailureTrackingsApi.
 * @export
 * @interface FailureTrackingsApiUpdateFailureTrackingRequest
 */
export interface FailureTrackingsApiUpdateFailureTrackingRequest {
    /**
     * 
     * @type {string}
     * @memberof FailureTrackingsApiUpdateFailureTracking
     */
    readonly id: string

    /**
     * 
     * @type {PutFailureTrackingRequest}
     * @memberof FailureTrackingsApiUpdateFailureTracking
     */
    readonly putFailureTrackingRequest: PutFailureTrackingRequest
}

/**
 * FailureTrackingsApi - object-oriented interface
 * @export
 * @class FailureTrackingsApi
 * @extends {BaseAPI}
 */
export class FailureTrackingsApi extends BaseAPI {
    /**
     * 
     * @param {FailureTrackingsApiCloseFailureTrackingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FailureTrackingsApi
     */
    public closeFailureTracking(requestParameters: FailureTrackingsApiCloseFailureTrackingRequest, options?: AxiosRequestConfig) {
        return FailureTrackingsApiFp(this.configuration).closeFailureTracking(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FailureTrackingsApiCreateFailureTrackingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FailureTrackingsApi
     */
    public createFailureTracking(requestParameters: FailureTrackingsApiCreateFailureTrackingRequest, options?: AxiosRequestConfig) {
        return FailureTrackingsApiFp(this.configuration).createFailureTracking(requestParameters.postFailureTrackingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FailureTrackingsApiDeleteFailureTrackingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FailureTrackingsApi
     */
    public deleteFailureTracking(requestParameters: FailureTrackingsApiDeleteFailureTrackingRequest, options?: AxiosRequestConfig) {
        return FailureTrackingsApiFp(this.configuration).deleteFailureTracking(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FailureTrackingsApiExportFailureTrackingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FailureTrackingsApi
     */
    public exportFailureTracking(requestParameters: FailureTrackingsApiExportFailureTrackingRequest = {}, options?: AxiosRequestConfig) {
        return FailureTrackingsApiFp(this.configuration).exportFailureTracking(requestParameters.keyword, requestParameters.status, requestParameters.openDate, requestParameters.closedDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FailureTrackingsApiGetFailureTrackingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FailureTrackingsApi
     */
    public getFailureTracking(requestParameters: FailureTrackingsApiGetFailureTrackingRequest, options?: AxiosRequestConfig) {
        return FailureTrackingsApiFp(this.configuration).getFailureTracking(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FailureTrackingsApiGetFailureTrackingsByKeywordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FailureTrackingsApi
     */
    public getFailureTrackingsByKeyword(requestParameters: FailureTrackingsApiGetFailureTrackingsByKeywordRequest = {}, options?: AxiosRequestConfig) {
        return FailureTrackingsApiFp(this.configuration).getFailureTrackingsByKeyword(requestParameters.keyword, requestParameters.limit, requestParameters.page, requestParameters.orderBy, requestParameters.orderDesc, requestParameters.status, requestParameters.openDate, requestParameters.closedDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FailureTrackingsApiUpdateFailureTrackingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FailureTrackingsApi
     */
    public updateFailureTracking(requestParameters: FailureTrackingsApiUpdateFailureTrackingRequest, options?: AxiosRequestConfig) {
        return FailureTrackingsApiFp(this.configuration).updateFailureTracking(requestParameters.id, requestParameters.putFailureTrackingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
